module.exports = __webpack_public_path__ + "static/media/11S.d1cfc067.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/11S.svg
// module id = 40
// module chunks = 0